import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import Ticket, { TicketItem, emptyTicket } from "./RestTicket";
import {
  CurrencyPaymentMethod,
  IClient,
  TicketPaymentGetway,
} from "models/PaymentModel";
import { IExternalOperation } from "amnPos/shiftsAndExternals/externalOperations/ExternalOperationData";
import { IAllowedApproval } from "amnPos/ticket/Ticket";
import { IDeliveryOrderInfo } from "amnShared/interfaces/IDeliveryOrderInfo";
import { IPickUpOrderInfo } from "amnShared/interfaces/IPickUpOrderInfo";

const initialState: Ticket = { ...emptyTicket };

export const RestTicketSlice = createSlice({
  name: "restTicket",
  initialState,
  reducers: {
    initialize: (state) => initialState,
    addTicketNote: (state, action: PayloadAction<string>) => {
      state.note = action.payload;
    },
    updateTicket: (state, action: PayloadAction<Ticket>) => {
      state = action.payload;
      return state;
    },
    updateTicketDeliveryOrderInfo: (
      state,
      action: PayloadAction<IDeliveryOrderInfo>,
    ) => {
      state.deliveryOrderInfo = action.payload;
      return state;
    },
    updateTicketPickupOrderInfo: (
      state,
      action: PayloadAction<IPickUpOrderInfo>,
    ) => {
      state.pickupOrderInfo = action.payload;
      return state;
    },
    addTicketItem: (state, action: PayloadAction<TicketItem>) => {
      state.ticketItems.push(action.payload);
      return state;
    },
    updateTicketItem: (state, action: PayloadAction<TicketItem>) => {
      state.ticketItems.map((o, key) => {
        if (o.id === action.payload.id) {
          state.ticketItems[key] = action.payload;
        }

        return state;
      });
    },
    deleteTicketItem: (state, action: PayloadAction<string>) => {
      state.ticketItems = state.ticketItems.filter(
        (o) => !action.payload.includes(o.id),
      );
      return state;
    },
    updatePayments: (state, action: PayloadAction<TicketPaymentGetway[]>) => {
      state.ticketPaymentGetways = action.payload;
      return state;
    },
    addPayment: (state, action: PayloadAction<TicketPaymentGetway>) => {
      state.ticketPaymentGetways.push(action.payload);
      return state;
    },
    updateExternalOperationPayments: (
      state,
      action: PayloadAction<IExternalOperation[]>,
    ) => {
      state.externalOperations = action.payload;
      return state;
    },
    addApproval: (state, action: PayloadAction<IAllowedApproval[]>) => {
      state.allowedApprovals?.push(...action.payload);
      return state;
    },
    addExternalOperationPayment: (
      state,
      action: PayloadAction<IExternalOperation>,
    ) => {
      if (state.externalOperations) {
        state.externalOperations.push(action.payload);
      } else {
        state.externalOperations = [action.payload];
      }
      return state;
    },
    addClientToTicket: (state, action: PayloadAction<IClient>) => {
      if (state.ticketItems.length > 0) {
        state.clientId = action.payload.id;
        state.client = action.payload.name;
      }
      return state;
    },
  },
});

export const {
  initialize,
  updateTicket,
  addTicketItem,
  updateTicketItem,
  deleteTicketItem,
  addClientToTicket,
  addTicketNote,
  updatePayments,
  addPayment,
  updateExternalOperationPayments,
  addExternalOperationPayment,
  addApproval,
  updateTicketDeliveryOrderInfo,
  updateTicketPickupOrderInfo,
} = RestTicketSlice.actions;

export const selectRestTicketItem = (state: RootState) => state.ticket;

export default RestTicketSlice.reducer;
